module.exports = __webpack_public_path__ + "static/img/coupon_used.5fdb70e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/benefits/coupon_used.png
// module id = 1480
// module chunks = 191